export default "__VITE_ASSET__wtcoTxJ$__"